import styled from "styled-components";

const Title = styled.h1`
  width: 100%;
  font-size: 25px;
  justify-content: center;
  font-family: "MaruBuri-Bold";

  @media (min-width: 360px) and (max-width: 600px) {
    font-size: 17px;
  }
`;
export default Title;
